import React, {
  useMemo, useState, useEffect,
} from 'react';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { Button, Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Cancel } from '../../media/images/Cancel';
// import { LocalizationContext } from '../Localization/LocalizationProvider';
import './Style.scss';
import DataTable from '../DataTable';
import { TypesHotelSearchModal } from './Type';
import { RootState } from '../../redux/rootState';
import { getHotelList } from '../../Screens/JobScheduling/UnscheduledJobs/addJob/redux/jobScheduleSlice';
import { formatHotelListData } from '../../Screens/JobScheduling/UnscheduledJobs/utils/helper';
import { AccommodationTableData } from '../../Screens/JobScheduling/UnscheduledJobs/utils/types';
import { setLoader } from '../../redux/loaderSlice';
import { defaultPageSize } from '../../utils/Constant';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '85%',
  // height: 'fit-content',
  bgcolor: 'background.paper',
  borderRadius: '6px',
  boxShadow: 24,
  p: '6px 24px 24px 24px',
  height: 'auto',
  '@media (max-width: 768px)': {
    p: '6px 6px 15px',
    height: 'auto',
  },
};
export default function HotelListingModal({
  show, setOpenFrom, selectedRadio, setSelectedRadio, onSelect,
}: TypesHotelSearchModal) {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(defaultPageSize);
  const [searchQuery, setSearchQuery] = useState('');
  const [sortCol, setSortCol] = useState('');
  const [sortDir, setSortDir] = useState('asc');
  const { hotelListData, isHotelListLoading } = useSelector((state: RootState) => state.jobScheduleReducer);
  const dispatch = useDispatch();

  const handleData = () => {
    const params = {
      page,
      rowsPerPage,
      searchQuery,
      sortCol,
      sortDir,
    };
    dispatch(getHotelList(params));
  };

  useEffect(() => {
    handleData();
  }, [page, rowsPerPage, searchQuery, sortCol, sortDir]);
  useEffect(() => {
    dispatch(setLoader(isHotelListLoading));
  }, [isHotelListLoading]);

  const columns = useMemo(
    () => [
      { key: 'sn', label: '' },
      { key: 'cityName', label: 'City' },
      { key: 'stateName', label: 'State' },
      { key: 'HotelName', label: 'Motel' },
      { key: 'jobCode', label: 'Job#' },
      { key: 'phoneNumber', label: 'Phone' },
      { key: 'dateIn', label: 'Date In' },
      { key: 'price', label: 'Price' },
    ],
    [],
  );

  return (
    <div>
      <Modal
        open={show}
        onClose={setOpenFrom}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <div className="customerInfo_container flex-row">
            <div className="customerInfo">
              Hotels
            </div>
            <div className="cancel-icon" onClick={setOpenFrom}>
              <Cancel />
            </div>
          </div>
          <DataTable<AccommodationTableData>
            data={formatHotelListData(hotelListData?.Data)}
            columns={columns}
            totalRecords={hotelListData?.TotalRecords}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
            searchQuery={searchQuery}
            setSearchQuery={(e) => { setSearchQuery(e); setPage(1); }}
            sortCol={sortCol}
            setSortCol={(e) => { setSortCol(e); setPage(1); }}
            sortDir={sortDir}
            setSortDir={(e) => { setSortDir(e); setPage(1); }}
            handleData={handleData}
            radioButtonColumns={['sn']}
            selectedRadio={selectedRadio}
            setSelectedRadio={setSelectedRadio}
            handleDataFromComponent
          />
          <Grid item md={12} sm={12} xs={12}>
            <div className="save_and_next_div">
              <div>
                <Button onClick={setOpenFrom} className="button_cancel">Cancel</Button>
              </div>
              <div className="button_margin_left">
                <Button
                  onClick={onSelect}
                  disabled={selectedRadio === ''}
                  className={selectedRadio === '' ? ' disableBtn' : 'button_save_and_next'}
                >
                  Select
                </Button>
              </div>
            </div>
          </Grid>
        </Box>
      </Modal>
    </div>
  );
}
